import React, { useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../components/common/PageHeader";
import GoToTop from "../helpers/GoToTop";
import MetaData from "../helpers/MetaData";
import notification from "../helpers/notification";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useForm } from "react-hook-form";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "bootstrap/dist/css/bootstrap.min.css";
import "@splidejs/react-splide/css"; // Needed for Splide styles
import "../css/bhadrA.css";

const prices = {
    English: 8500,
    Hindi: 6900,
    Gujarati: 7500,
    Marathi: 6100,
    Tamil: 7000,
    Telugu: 6100,
    Oriya: 7100,
    Bengali: 6900,
};
const languages = Object.keys(prices);

const images = [
    "/images/campaign/sliderimage1.jpeg",
    "/images/campaign/sliderimage2.jpeg",
    "/images/campaign/sliderimage3.jpeg",
    "/images/campaign/sliderimage4.jpeg",
    "/images/campaign/sliderimage5.jpeg",
];

const BhadraPurnima = () => {
    const navigate = useNavigate();
    const slider2 = useRef();
    const sliderRef = useRef(null);
    const [amount, setAmount] = useState("");
    const [donateQuantities, setDonateQuantities] = useState(
        Object.fromEntries(languages.map((lang) => [lang, 0]))
    );
    const [purchaseQuantities, setPurchaseQuantities] = useState(
        Object.fromEntries(languages.map((lang) => [lang, 0]))
    );
    const { register, handleSubmit, control, setValue, getValues } = useForm({
        defaultValues: { state: "", city: "" },
    });

    // --- Quantity logic ---
    const updateQuantity = (type, language, delta) => {
        const setter =
            type === "donate" ? setDonateQuantities : setPurchaseQuantities;
        setter((prev) => ({
            ...prev,
            [language]: Math.max((prev[language] || 0) + delta, 0),
        }));
    };
    const calculateTotal = (quantities) =>
        Object.keys(quantities).reduce(
            (total, lang) => total + quantities[lang] * (prices[lang] || 0),
            0
        );
    const donateTotalAmount = calculateTotal(donateQuantities);
    const purchaseTotalAmount = calculateTotal(purchaseQuantities);

    // --- Handle actions ---
    const handleDonateClick = (type = "donate") => {
        const quantities =
            type === "donate" ? donateQuantities : purchaseQuantities;
        const totalAmount =
            type === "donate" ? donateTotalAmount : purchaseTotalAmount;
        const hasSelectedBooks = Object.values(quantities).some((qty) => qty > 0);
        if (!hasSelectedBooks) {
            notification("error", "Please select at least one book");
            return;
        }
        const bookDetails = Object.keys(quantities)
            .filter((lang) => quantities[lang] > 0)
            .map((lang) => ({
                language: lang,
                quantity: quantities[lang],
                price: prices[lang],
                totalPrice: quantities[lang] * prices[lang],
            }));

        if (type === "donate") {
            localStorage.setItem("bookDetails", JSON.stringify(bookDetails));
            localStorage.setItem("totalAmount", totalAmount);
            localStorage.setItem("donationType", type);
            localStorage.setItem("campaignType", "bhadra-purnima");
            navigate(`/campaign-donation/bhadra-purnima/${totalAmount}`, {
                state: { bookDetails: JSON.stringify(bookDetails) },
            });

        } else if (type === "purchase") {
            navigate(`/bhadra-purnima-checkout`, {
                state: {
                    price: totalAmount,
                    bookDetails: bookDetails,
                    campaignType: "bhadra-purnima",
                },
            });
        }
    };
    const donanybtn = (fixedAmount) => {
        const finalAmount = fixedAmount || amount;

        if (!finalAmount || finalAmount <= 0) {
            notification("error", "Please Enter Valid Amount");
            return;
        }

        localStorage.removeItem("bookDetails");
        localStorage.setItem("totalAmount", finalAmount);
        localStorage.setItem("donationType", "any-amount");
        localStorage.setItem("campaignType", "bhadra-purnima");
        window.location.href = (`/campaign-donation/bhadra-purnima/${finalAmount}`)
        // navigate(`/campaign-donation/bhadra-purnima/${finalAmount}`);
    };
    // --- Table and selectors ---
    const QuantitySelector = ({ type, language, quantity }) => (
        <div className="quantity-selector">
            <button
                type="button"
                onClick={() => updateQuantity(type, language, -1)}
                disabled={quantity <= 0}
            >
                -
            </button>

            <span>{quantity}</span>

            <button type="button" onClick={() => updateQuantity(type, language, 1)}>
                +
            </button>
        </div>
    );

    // --- UI ---
    return (
        <>
            <MetaData title="Campaigns - ISKCON of Attapur" />
            <section className="campaigns-wrap mobile-margin-top scrolling-stop">
                <div className="bhadra-container py-0">
                    {/* Header */}
                    <div className="row mb-0">
                        <section className="bhadra-hero pb-4">
                            <div className="hero-content">
                                <div className="bhadra-container">
                                    <div className="row">
                                        <div className="col-lg-10 col-sm-12 mx-auto text-center">
                                            {/* Top Badge */}
                                            <div className="hero-badge">
                                                <span className="badge-icon">✨</span>
                                                <span>The Supreme Gift of Srimad Bhagavatam</span>
                                            </div>

                                            {/* Title */}
                                            <h1 className="hero-title">BHADRA PURNIMA 2025</h1>

                                            {/* Subtitle / Description */}
                                            {/* <p className="hero-subtitle">
                                                Serve the Srimad Bhagavatam by buying a set for yourself
                                                or giving it to your friends, family members, relatives,
                                                and co-workers. There's no better gift, and there's no
                                                better time to give it.
                                            </p>

                                         
                                            <p className="hero-quote">
                                                If on the full moon day of the month of Bhadra, one
                                                places Srimad-Bhagavatam on a golden throne and gives it
                                                as a gift, he will attain the supreme transcendental
                                                destination – <strong>SB 12.13.13</strong>
                                            </p> */}
                                            <p className="hero-subtitle">
                                                Serve the Śrīmad-Bhāgavatam, the spotless Purāṇa, by securing a set for yourself or by gifting it to your friends, family members, relatives, and colleagues. There is no greater gift—and no better time to share it.
                                            </p>

                                            {/* Quote */}
                                            <p className="hero-quote">
                                                The scriptures declare: <br />
                                                “On the full moon day of the month of Bhādra, one who
                                                gifts the Śrīmad-Bhāgavatam attains the supreme
                                                spiritual destination.” <br />—{" "}
                                                <strong>Śrīmad-Bhāgavatam 12.13.13</strong>
                                            </p>

                                            {/* Info row */}
                                            <div className="row mt-5 justify-content-center">
                                                <div className="col-md-6 text-center">
                                                    <div className="highlight-date">
                                                        <span>Sunday, 7 September 2025</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="bhadra-subtext">
                            <div className="container text-center">
                                <h2>
                                    Celebrate Bhādra Purnimā by gifting the timeless treasure of the Śrīmad-Bhāgavatam
                                </h2>
                                <div className="col-12 d-flex justify-content-center pb-4">
                                    <picture>
                                        {/* Mobile Image (max 480px) */}
                                        <source
                                            media="(max-width: 480px)"
                                            srcSet="/images/campaign/ATP_Bhadra Purnima_Mob.webp"
                                        />

                                        {/* Default / Desktop Image */}
                                        <img
                                            style={{
                                                width: "100%",
                                                maxWidth: "1300px",
                                                borderRadius: 8,
                                                boxShadow: "0 2px 12px #d3d3d3",
                                            }}
                                            src="/images/campaign/ATP_Bhadra Purnima.webp"
                                            alt="Bhadra Purnima"
                                        />
                                    </picture>
                                </div>
                            </div>
                        </section>
                    </div>

                    {/* Table + slideshow row */}
                    <section className="purchase-book-section">
                        <div
                            className="row align-items-start website-view"
                            style={{ backgroundColor: "#F4F3F1" }}
                        >
                            {/* Table Tabs/Box */}
                            <div className="col-md-7 col-xl-8 mb-lg-7 mb-4 responsive-wrapper">
                                <div className="bg-light rounded shadow-sm p-3 p-md-4">
                                    <Tabs
                                        defaultActiveKey="donate"
                                        id="donate-purchase-tabs"
                                        className="mb-3"
                                    >
                                        <Tab
                                            eventKey="donate"
                                            title={
                                                <span
                                                    style={{ fontWeight: "bold", fontSize: "1.1rem" }}
                                                >
                                                    Donate
                                                </span>
                                            }
                                        >
                                            <div className="table-responsive">
                                                <table className="table table-bordered align-middle mb-0 responsive-table">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <td className="text-center">
                                                                I would like to support
                                                            </td>
                                                            <td className="text-center">₹ 1,500</td>
                                                            <td className="text-center">
                                                                <button onClick={() => donanybtn(1500)} className="btn w-100" type="button" style={{ backgroundColor: "black", color: "white" }}>
                                                                    Donate
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center">
                                                                I would like to support
                                                            </td>
                                                            <td className="text-center">₹ 3,000</td>
                                                            <td className="text-center">
                                                                <button onClick={() => donanybtn(3000)} className="btn w-100" type="button" style={{ backgroundColor: "black", color: "white" }}>
                                                                    Donate
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center">
                                                                I would like to support
                                                            </td>
                                                            <td className="text-center">₹ 6,000</td>
                                                            <td className="text-center">
                                                                <button onClick={() => donanybtn(6000)} className="btn w-100" type="button" style={{ backgroundColor: "black", color: "white" }}>
                                                                    Donate
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center">
                                                                I would like to support
                                                            </td>
                                                            <td className="text-center">₹ 15,000</td>
                                                            <td className="text-center">
                                                                <button onClick={() => donanybtn(15000)} className="btn w-100" type="button" style={{ backgroundColor: "black", color: "white" }}>
                                                                    Donate
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr className="align-middle">
                                                            <td className="text-center fw-semibold">
                                                                Donate any amount
                                                            </td>
                                                            <td
                                                                className="text-center"
                                                                style={{ maxWidth: "150px" }}
                                                            >
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center"
                                                                    value={amount}
                                                                    min={"0"}
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => setAmount(e.target.value)}
                                                                    placeholder="₹ Amount"
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    onClick={() => donanybtn()}
                                                                    className="btn w-100"
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: "black",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                    Donate
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr style={{ border: "none" }}>
                                                            <td colSpan="3" className="text-center" style={{ border: "none" }}>
                                                                <div className="py-3">
                                                                    <h1 className="h4 fw-bold mb-0">Support for Full Srimad Bhagavatam Set</h1>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-center">Language</th>
                                                            <th className="text-center">Price</th>
                                                            <th className="text-center">Quantity</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {languages.map((language) => (
                                                            <tr key={language}>
                                                                <td
                                                                    className="text-center"
                                                                    style={{ fontWeight: 500 }}
                                                                >
                                                                    {language}
                                                                </td>
                                                                <td className="text-center">
                                                                    ₹ {prices[language].toLocaleString()}
                                                                </td>
                                                                <td className="text-center">
                                                                    <QuantitySelector
                                                                        type="donate"
                                                                        language={language}
                                                                        quantity={donateQuantities[language]}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {/* Total row */}
                                                        <tr>
                                                            <td
                                                                className="text-center"
                                                                style={{ fontWeight: 500 }}
                                                            >
                                                                Total Amount
                                                            </td>
                                                            <td style={{ maxWidth: "120px" }}>
                                                                <input
                                                                    type="text"
                                                                    className="form-control text-center"
                                                                    value={
                                                                        donateTotalAmount
                                                                            ? `₹ ${donateTotalAmount.toLocaleString()}`
                                                                            : ""
                                                                    }
                                                                    readOnly
                                                                    placeholder="₹ Amount"
                                                                    style={{
                                                                        color: "#888888",
                                                                        fontFamily: "Barlow",
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    onClick={() => handleDonateClick("donate")}
                                                                    className="btn w-100"
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: "black",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                    Donate
                                                                </button>
                                                            </td>
                                                        </tr>

                                                        {/* Any amount row */}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Tab>
                                        <Tab
                                            eventKey="purchase"
                                            title={
                                                <span
                                                    style={{ fontWeight: "bold", fontSize: "1.1rem" }}
                                                >
                                                    Purchase
                                                </span>
                                            }
                                        >
                                            <div className="table-responsive">
                                                <table className="table table-bordered align-middle mb-0 responsive-table">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th className="text-center">Language</th>
                                                            <th className="text-center">Price</th>
                                                            <th className="text-center">Quantity</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {languages.map((language) => (
                                                            <tr key={language}>
                                                                <td
                                                                    className="text-center"
                                                                    style={{ fontWeight: 500 }}
                                                                >
                                                                    {language}
                                                                </td>
                                                                <td className="text-center">
                                                                    ₹ {prices[language].toLocaleString()}
                                                                </td>
                                                                <td className="text-center">
                                                                    <QuantitySelector
                                                                        type="purchase"
                                                                        language={language}
                                                                        quantity={purchaseQuantities[language]}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {/* Total row */}
                                                        <tr>
                                                            <td
                                                                className="text-center"
                                                                style={{ fontWeight: 500 }}
                                                            >
                                                                Total Amount
                                                            </td>
                                                            <td style={{ maxWidth: "120px" }}>
                                                                <input
                                                                    type="text"
                                                                    className="form-control text-center"
                                                                    value={
                                                                        purchaseTotalAmount
                                                                            ? `₹ ${purchaseTotalAmount.toLocaleString()}`
                                                                            : ""
                                                                    }
                                                                    readOnly
                                                                    placeholder="₹ Amount"
                                                                    style={{
                                                                        color: "#888888",
                                                                        fontFamily: "Barlow",
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    onClick={() => handleDonateClick("purchase")}
                                                                    className="btn w-100"
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: "black",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                    Purchase
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                            {/* End Table block */}

                            {/* Slideshow */}
                            <div className="col-lg-5 col-xl-4 mb-4">
                                <div className="story-slider">
                                    {/* Main Slider */}
                                    <Splide
                                        ref={sliderRef}
                                        options={{
                                            type: "fade",
                                            rewind: true,
                                            pagination: false, // Disable default pagination since we have thumbnails
                                            arrows: false,
                                            height: "auto",
                                            width: "100%",
                                            autoplay: false,
                                            speed: 600,
                                            easing: "ease",
                                        }}
                                        aria-label="Bhagavatam set images"
                                        className="splide-wrapper"
                                    >
                                        {images.map((src, i) => (
                                            <SplideSlide key={i}>
                                                <div className="slide-container">
                                                    <img
                                                        src={src}
                                                        alt={`Bhagavatam set slide ${i + 1}`}
                                                        className="slider-image"
                                                        loading={i === 0 ? "eager" : "lazy"}
                                                    />
                                                </div>
                                            </SplideSlide>
                                        ))}
                                    </Splide>

                                    {/* Thumbnails */}
                                    <div
                                        className="thumbnail-wrapper d-flex mt-3 gap-2 overflow-auto"
                                        style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
                                    >
                                        {images.map((src, i) => (
                                            <img
                                                key={i}
                                                src={src}
                                                alt={`thumb${i}`}
                                                className="thumbnail"
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100px",
                                                    cursor: "pointer",
                                                }} // adjust width as needed
                                                onClick={() => {
                                                    if (sliderRef.current && sliderRef.current.splide) {
                                                        sliderRef.current.splide.go(i);
                                                    }
                                                }}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Bottom Section */}
                    <div className="row" style={{ marginTop: "32px" }}>
                        <div className="col-lg-8 col-sm-12 mx-auto">
                            <div className="dual-heading center">
                                <h3>
                                    Join Us in Distributing the Bhagavad Gita Freely to Thousands
                                </h3>
                            </div>
                            <div className="live-video-wrap mt-3">
                                <div
                                    style={{
                                        position: "relative",
                                        paddingBottom: "56.25%",
                                        height: 0,
                                    }}
                                >
                                    <iframe
                                        src="https://www.youtube.com/embed/6OgvQ3TCZKI"
                                        allowFullScreen
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            border: 0,
                                        }}
                                        title="Free Bhagavad Gita Distribution Drive"
                                    />
                                </div>
                                <div className="news-details mt-3">
                                    <h4>Free Bhagavad Gita Distribution Drive</h4>
                                    {/* <p>
                                        Thousands of copies of the sacred Bhagavad Gita were
                                        distributed to devotees and the public, spreading the
                                        timeless wisdom of Lord Krishna.
                                    </p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <GoToTop />
            {/* Inline Styles for extra fine tuning as per screenshot */}
        </>
    );
};

export default BhadraPurnima;
